module.exports = __webpack_public_path__ + "static/media/VIEWS.94d729d1.svg";